import * as actions from "./actions";

const initialState = {
	item: null,
	loading: {}
};

const reducer = function(state = initialState, { type, payload }) {
	switch (type) {
		case actions.GET_TAX: {
			return {
				...state,
				loading: { get: true }
			};
		}
		case actions.DELETE_TAX: {
			return {
				...state,
				loading: { delete: true }
			};
		}
		case actions.DELETE_TAX_SUCCESS: {
			return {
				...state,
				loading: { delete: false }
			};
		}
		case actions.DELETE_TAX_ERROR: {
			return {
				...state,
				errors: payload,
				loading: { delete: false }
			};
		}
		case actions.GET_TAX_SUCCESS: {
			return {
				...state,
				item: payload,
				loading: { get: false }
			};
		}
		case actions.GET_TAX_ERROR: {
			return {
				...state,
				errors: payload,
				loading: { get: false }
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
